export default __webpack_public_path__ + "static/media/green-check-icon.45f1a284.svg";